import { render, staticRenderFns } from "./rancher-gatekeeper.vue?vue&type=template&id=1b72f089&"
import script from "./rancher-gatekeeper.vue?vue&type=script&lang=js&"
export * from "./rancher-gatekeeper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports